<template>
    <div class="keywordsAssistant">
        <el-dialog :close-on-click-modal="false" title="关键词拓展" :visible.sync="dialogVisible"
            :before-close="handleClose">
            <el-input v-model="url" placeholder="输入网址，可以是竞争对手的网址"></el-input>
            <div class="display">
                <el-input type="textarea" placeholder="输入用来拓词的种子关键词，每行一条，超出20条的部分将忽略" :autosize="{ minRows: 8, maxRows: 8 }"
                    v-model="seedwords"></el-input>
                <div class="bt_display">
                    <span @click="insertKeyword">插入已选定的关键词</span>
                    <span style="float:right" @click="clearWords">清空</span>
                </div>
            </div>
            <el-row :gutter="24">
                <el-col :span="12">
                    <div>位置范围：{{ positionTags.length ? positionTags.map((obj) => { return obj.value; }).join("、") : '全球' }}
                    </div>
                    <el-autocomplete class="distance" v-model="position" :fetch-suggestions="querySearch"
                        placeholder="输入国家/地区，最多10个" :trigger-on-focus="false" @select="handleSelect"></el-autocomplete>
                    <el-tag style="margin:0 1px 5px 0 " v-for="tag in positionTags" :key="tag.name" closable
                        @close="removeTag(tag)">
                        {{ tag.value }}
                    </el-tag>
                    <div>语言范围：{{ languageObject.languageNameZh || '英语' }}</div>
                    <el-select class="distance" v-model="language" placeholder="选择语言，单选" @change="getLanguage">
                        <el-option v-for="item in languageList" :key="item.criterionId" :label="item.languageNameZh"
                            :value="item.criterionId">
                        </el-option>
                    </el-select>
                    <div>日期范围：{{ date ? timeChange(date[0]) + ' 至 ' + timeChange(date[1]) : '过去12个月' }}</div>
                    <el-date-picker class="distance" v-model="date" type="monthrange" range-separator="至"
                        start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions">
                    </el-date-picker>
                    <div>投放网络：{{ networkObject.label || 'Google和搜索网络合作伙伴' }}</div>
                    <el-select class="distance" v-model="network" placeholder="选择投放网络，单选" @change="getNetwork">
                        <el-option v-for="item in networkList" :key="item.value" :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-col>
                <el-col :span="12">
                    <div>结果过滤条件</div>
                    <div class="filter">
                        <div>
                            <el-checkbox v-model="seedFilter">过滤种子关键词本身</el-checkbox>
                        </div>
                        <div class="checkbox">
                            <el-checkbox v-model="selectedFilter">过滤已选择的产品关键词</el-checkbox>
                        </div>
                        <div>
                            <el-checkbox v-model="unwantedFilter">过滤不需要投放广告的产品关键词</el-checkbox>
                        </div>
                    </div>
                </el-col>
            </el-row>
            <span slot="footer" class="dialog-footer">
                <el-button :disabled="disabled" type="primary" @click="closeDialog">开始拓词</el-button>
            </span>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" title="关键词助手" :visible.sync="helpDialog">
            <el-table v-loading="loading" ref="multipleTable" :row-key="getRowKey"
                :data="keywordData" tooltip-effect="dark"
                style="width: 100%" @selection-change="handleSelectionChange" height="400">
                <el-table-column type="selection" :reserve-selection="true" width="100">
                </el-table-column>
                <el-table-column label="关键词" width="300">
                    <template slot-scope="scope">{{ scope.row.keyword }}</template>
                </el-table-column>
                <el-table-column prop="searchNum" label="平均每月搜索量" width="200">
                </el-table-column>
                <el-table-column prop="compete" label="竞争程度" show-overflow-tooltip>
                </el-table-column>
            </el-table>
            <div class="total">本页共计{{keywordData.length}}条</div>
            <el-button :disabled="nextPage" type="primary" plain class="nextpage" size="small" @click="keywordFoldable">下一页</el-button>
            <span slot="footer" class="dialog-footer">
                <el-button @click="Goback">返 回</el-button>
                <el-button type="primary" @click="saveSelected">保存选中({{selectedWords.length}})</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import adsNewOnlineSer from '@/backend/services/adsNewOnline/adsNewOnlineSer.js'
export default {
    props: ['dialogVisible', 'textarea', 'keywordsList', "domain"],
    data() {
        return {
            nextPage: true,
            loading: false,
            disabled: true,
            helpDialog: false,
            url: '',
            seedwords: '',
            position: '',
            language: '',
            languageObject: {},
            date: '',
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() > new Date().setMonth(new Date().getMonth() - 1) || time.getTime() < new Date().setMonth(new Date().getMonth() - 48);
                }
            },
            network: '',
            networkObject: {},
            seedFilter: true,
            selectedFilter: true,
            unwantedFilter: true,
            positionTags: [],
            languageList: [],
            networkList: [
                { value: 0, label: 'Google和搜索网络合作伙伴' },
                { value: 1, label: 'Google' }
            ],
            keywordData: [],
            selectedWords: [],
            nextPageToken: '',
        }
    },
    methods: {
        async adLanguage() {
            let res = await adsNewOnlineSer.adLanguage();
            this.languageList = res.data;
        },
        async querySearch(queryString, cb) {
            let res = await adsNewOnlineSer.getgeotargets({
                name: queryString
            });
            let geotargetsOne = res.data;
            let results = [];
            let geolist = JSON.parse(JSON.stringify(geotargetsOne).replace(/name/g, 'value'))
            results = queryString ? geolist : results;
            cb(results);
        },
        async keywordFoldable() {
            this.loading = true;
            let geoTargetConstants = this.positionTags.map((obj) => { return obj.id; });
            let keywords = this.seedwords.split('\n').filter(item => item).map(s => { return s.trim() })
            keywords.splice(20);
            try {
                let res = await adsNewOnlineSer.keywordFoldable({
                    automationContentId: this.$attrs.automationContentId,
                    end: this.date[1] ? this.timeChange(this.date[1]) : "",
                    existenceKeyword: this.selectedFilter ? 1 : 0,
                    geoTargetConstants: geoTargetConstants,
                    keywordItself: this.seedFilter ? 1 : 0,
                    keywordPlanNetwork: this.network,
                    keywords: keywords,
                    language: this.language,
                    nextPageToken: this.nextPageToken,
                    pageSize: 100,
                    start: this.date[0] ? this.timeChange(this.date[0]) : "",
                    unwantedKeyword: this.unwantedFilter ? 1 : 0,
                    url: this.url,
                }, { serviceSiteId: this.$route.query.serviceSiteId });
                this.keywordData = res.data.productKeywordVOS || [];
                this.nextPageToken = res.data.nextPageToken;
                this.loading = false;
                this.nextPage = res.data.nextPageToken ? false : true;
            } catch (error) {
                console.log(error);
            }
        },
        getLanguage(value) {
            this.languageObject = this.languageList.find((item) => {
                return item.criterionId === value;
            });
        },
        getNetwork(value) {
            this.networkObject = this.networkList.find((item) => {
                return item.value === value;
            });
        },
        handleClose() {
            this.$emit('extentWords', false)
        },
        closeDialog() {
            this.$emit('extentWords', false);
            this.nextPageToken = '';
            this.keywordFoldable();
            this.helpDialog = true;
        },
        handleSelect(item) {
            if(this.positionTags.length < 10){
                this.positionTags.push(item);
            }else{
                this.$message.warning("最多只能选10个");
            }
            this.position = '';
        },
        removeTag(tag) {
            this.positionTags.splice(this.positionTags.indexOf(tag), 1);
        },
        handleSelectionChange(val) {
            this.selectedWords = val;
        },
        saveSelected() {
            this.helpDialog = false;
            this.selectedWords.forEach(item => {
                item.enterType = 0;
            });
            this.$emit("addExtension", this.selectedWords);
            this.selectedWords = [];
            this.$refs.multipleTable.clearSelection();
        },
        Goback() {
            this.helpDialog = false;
            this.$emit('extentWords', true);
            this.selectedWords = [];
            this.$refs.multipleTable.clearSelection();
        },
        insertKeyword() {
            this.seedwords = this.keywordsList.map(item => { return item.keyword }).join('\n');
        },
        clearWords() {
            this.seedwords = '';
        },
        timeChange(UTCDateString) {
            if (!UTCDateString) {
                return '-';
            }
            function formatFunc(str) {
                return str > 9 ? str : '0' + str
            }
            var date2 = new Date(UTCDateString);
            var year = date2.getFullYear();
            var mon = formatFunc(date2.getMonth() + 1);
            var dateStr = year + '-' + mon;
            return dateStr;
        },
        getRowKey(row) {
            return row.keyword;
        },
    },
    watch: {
        textarea: {
            handler(val) {
                this.seedwords = val;
            }
        },
        domain:{
            handler(val){
                this.url = val;
            }
        },
        url:{
            handler(val){
                if(val || this.seedwords){
                    this.disabled = false;
                }else{
                    this.disabled = true;
                }
            }
        },
        seedwords:{
            handler(val){
                if(val || this.url){
                    this.disabled = false;
                }else{
                    this.disabled = true;
                }
            }
        }
    },
    mounted() {
        this.adLanguage();
    }
}
</script>
<style lang="scss" scoped>
.keywordsAssistant {
    .display {
        margin: 10px 0 25px 0;
        padding: 5px;
        border: 1px solid #DCDFE6;
        border-radius: 4px;

        ::v-deep .el-textarea__inner {
            border: none !important;
            resize: none !important;
            /* 这个是去掉 textarea 下面拉伸的那个标志，如下图 */
            padding: 0 !important;

            &::-webkit-scrollbar {
                width: 4px;
            }

            &::-webkit-scrollbar-thumb {
                background-color: #e8e8e8;
                border-radius: 6px;
            }

            &::-webkit-scrollbar-track {
                background-color: #fff;
                border-radius: 2px;
            }
        }

        .bt_display {
            padding: 5px 10px;

            span {
                font-weight: 400;
                color: #3DA1FF;
                cursor: pointer;
            }
        }
    }

    .distance {
        margin: 10px 0 15px 0;
        width: 100%;
    }

    .filter {
        padding: 20px 20px;
        margin-top: 10px;
        width: 100%;
        height: 285px;
        border-radius: 4px;
        border: 1px solid #E3E3E3;

        .checkbox {
            margin: 15px 0;
        }
    }

    .total{
        margin-top: 15px
    }
    .nextpage{
        margin-top: -20px;
        float: right;
    }
    ::v-deep .el-date-editor .el-range-separator {
        padding: 0px !important;
    }
}
</style>